export default "__VITE_ASSET__DLajBNlW__"